/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const Description = styled.p<{ shouldWrap?: boolean }>`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.color.text.text02};
  margin-bottom: ${theme.spacing.spacing00};
  line-height: ${theme.lineHeight};
  white-space: ${(shouldWrap) => (shouldWrap ? "normal" : "nowrap")};
`;
